module.exports = __webpack_public_path__ + "img/icon-folder.ec139770.svg";